import { Check, Circle, CircleAlert } from "lucide-react";
import { cn } from "@/lib/utils/cn";
import { ChatActivityIndicator } from "@/components/ui/AiChatPanel/ChatActivityIndicator";

export const chatStatusLabels: Record<string, string> = {
  pending_approval: "Needs approval",
  running: "Working",
  completed_unread: "New response",
  failed_unread: "Needs attention",
  completed: "Completed",
  failed: "Stopped with an error",
  cancelled: "Stopped",
  idle: "Ready",
};

export function ChatStatus({
  status,
  compact = false,
}: {
  status: string;
  compact?: boolean;
}) {
  const label = chatStatusLabels[status] ?? "Ready";
  const waiting = status === "pending_approval";
  const failed = status === "failed" || status === "failed_unread";
  const unread = status === "completed_unread";
  const working = status === "running";
  const Icon = waiting || failed ? CircleAlert : unread ? Circle : Check;
  return (
    <span
      title={label}
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 text-xs",
        waiting
          ? "text-amber-700 dark:text-amber-400"
          : failed
            ? "text-destructive"
            : unread
              ? "text-blue-600 dark:text-blue-400"
              : "text-muted-foreground",
      )}
    >
      {working ? (
        <ChatActivityIndicator active />
      ) : (
        <Icon
          aria-hidden="true"
          className={cn("size-3.5", unread && "fill-current")}
        />
      )}
      <span className={compact ? "sr-only" : undefined}>{label}</span>
    </span>
  );
}
